import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import WebbLoader from "./webb-loader";

import { GetAuthUser } from "../services/user-accounts";
import { CreateRoomText } from "../services/user-accounts";

export default function RoomTextEnterModule(props) {

  const asset = GetAuthUser();
  const { id } = useParams();

  const [loading,setLoading]=useState(true);
  const [data,setData]=useState({text:'', crus: asset.usid, rmid: id});


  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
   
    console.log (JSON.stringify(data))
    const response = await CreateRoomText(JSON.stringify({
      body: {...data, usid: asset.usid, form: asset.form}, 
      user: {usid: asset.usid, form: asset.form}
    }))
    console.log(response)
    handleChange("text", "");
    setLoading(false);
  }

  return (
    <>
    <form onSubmit={handleSubmit}>
      <div className="card px-3 py-1 rounded-wd border bg-white">

        <div className="d-flex">
          <div className="me-auto" style={{width:"79ch"}}>
            <input 
              type="text"     
              className="form-control height-md border-none"   
              value={data.text}
              onChange={({ target }) => {handleChange("text", target.value);}}
              placeholder="enter message">
            </input>
          </div>

          <div className="py-2" style={{width:'fit-content'}}>
            <button className="btn btn-sm btn-outline-primary border-none">Send</button>
          </div>

        </div>

      </div>
    </form>
    </>
  )
}